import { Toast } from '@shared/components/toast/interfaces';

export const ERROR_TOAST_GET_SUBSCRIBERS: Toast = {
  message: 'Error getting subscribers data',
  type: 'error',
};
